/* Hoggy's Grill: behaviour shared by every page (full-screen menu, site header, cart count, pixel scenes, sign-ups).
   The home page loads this alongside hg-home.js; every other page gets it from the header section. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var root = document.documentElement;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  var pixelLoad = null;
  function pixelScript(src) { return pixelLoad || (pixelLoad = loadScript(src)); } // hg-pixel.js, once

  /* ---------- Full-screen menu ---------- */
  function initMenu(menu) {
    var openBtns = Array.prototype.slice.call(document.querySelectorAll('[data-hg-menu-open]'));
    if (!menu || !openBtns.length) return;
    var closeBtn = menu.querySelector('[data-hg-menu-close]');
    var photos = Array.prototype.slice.call(menu.querySelectorAll('[data-hg-menu-photo]'));
    var scene = menu.querySelector('[data-hg-pixel]');
    var sceneStarted = false;
    var opener = null; // the button that opened the menu gets focus back when it closes
    var isOpen = false;
    var hideTimer = null;

    // The menu opens on the embers photo (number 0). The link photos only matter where you can hover, so phones
    // and tablets get just the opening photo, in its small size, and data-saver visitors get none.
    function loadPhotos() {
      if (saveData) return;
      photos.forEach(function (p) {
        var opening = p.dataset.hgMenuPhoto === '0';
        if (!finePointer && !opening) return;
        var src = !finePointer && p.dataset.srcSm ? p.dataset.srcSm : p.dataset.src;
        if (!src) return;
        p.style.backgroundImage = 'url("' + src + '")';
        p.removeAttribute('data-src');
        p.removeAttribute('data-src-sm');
      });
    }
    function showPhoto(n) {
      var key = n || '0'; // back to the embers when nothing is pointed at
      photos.forEach(function (p) { p.classList.toggle('is-on', p.dataset.hgMenuPhoto === key); });
    }
    // The pixel bowler loads on the first open; after that it bowls again every time the menu opens.
    function startScene() {
      if (!scene || sceneStarted) return;
      sceneStarted = true;
      var go = function () { window.HgPixel.mount(scene, { root: menu, delay: 550, replay: true }); };
      if (window.HgPixel) go(); else pixelScript(scene.getAttribute('data-hg-pixel-js')).then(go, function () {});
    }
    function focusables() {
      return Array.prototype.filter.call(menu.querySelectorAll('a[href], button:not([disabled])'), function (el) {
        return el.getClientRects().length > 0;
      });
    }
    function open(btn) {
      clearTimeout(hideTimer);
      opener = btn;
      isOpen = true;
      loadPhotos();
      showPhoto(null);
      menu.hidden = false;
      void menu.offsetWidth; // paint the closed state first so the reveal animates
      menu.classList.add('is-open');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      root.classList.add('hg-menu-lock');
      closeBtn.focus();
      startScene();
    }
    function close(skipFocus) {
      if (!isOpen) return;
      isOpen = false;
      menu.classList.remove('is-open');
      showPhoto(null);
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      root.classList.remove('hg-menu-lock');
      hideTimer = setTimeout(function () { menu.hidden = true; }, reduceMotion ? 0 : 700);
      if (opener && !skipFocus) opener.focus();
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', function () { open(btn); }); });
    closeBtn.addEventListener('click', function () { close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

    // Keep Tab inside the menu while it is open.
    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    // Email and phone links don't leave the page, so close the menu behind them.
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a[href^="mailto:"], a[href^="tel:"]')) close(true);
    });

    menu.querySelectorAll('[data-hg-menu-link]').forEach(function (a) {
      var n = a.getAttribute('data-hg-menu-link');
      a.addEventListener('pointerenter', function () { showPhoto(n); });
      a.addEventListener('focus', function () { showPhoto(n); });
    });
    var list = menu.querySelector('.hg-menu__nav ol');
    if (list) list.addEventListener('pointerleave', function () { showPhoto(null); });

    // Coming back with the browser's Back button can restore the page with the menu still open.
    window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen) close(true); });
  }

  /* ---------- Header: tucks away scrolling down, comes back scrolling up ---------- */
  function initHeader(head) {
    if (!head) return;
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      ticking = false;
      var y = Math.max(0, window.scrollY);
      head.classList.toggle('is-scrolled', y > 4);
      var dy = y - lastY;
      if (y > 160 && Math.abs(dy) < 8) return; // ignore small wobbles; lastY stays as the anchor
      var tuck = y > 160 && dy > 0 && !head.contains(document.activeElement) && !root.classList.contains('hg-menu-lock');
      head.classList.toggle('is-tucked', tuck);
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    // Tabbing into a tucked header brings it back.
    head.addEventListener('focusin', function () { head.classList.remove('is-tucked'); });
    update();
  }

  /* ---------- Cart count: kept in step when something is added, or the page comes back from the Back button ---------- */
  function initCartCount() {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-hg-cart]'));
    if (!links.length) return;
    function refresh() {
      var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = cart.item_count;
          links.forEach(function (link) {
            var count = link.querySelector('[data-hg-cart-count]');
            if (count) { count.textContent = n; count.hidden = !n; }
            link.setAttribute('aria-label', n ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
          });
        })
        .catch(function () {});
    }
    // Dawn's pubsub.js and constants.js load before this file (all deferred, in page order).
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  /* ---------- Pixel scenes and the game: hg-pixel.js loads when the first one comes near the screen ---------- */
  function initScenes() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-hg-pixel="auto"], [data-hg-game]'));
    if (!items.length) return;
    var src = items[0].getAttribute('data-hg-pixel-js');
    function start(el) {
      var go = function () { if (el.hasAttribute('data-hg-game')) window.HgPixel.game(el); else window.HgPixel.mount(el); };
      if (window.HgPixel) go(); else pixelScript(src).then(go, function () {});
    }
    if (!('IntersectionObserver' in window)) { items.forEach(start); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); start(e.target); } });
    }, { rootMargin: '300px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sign-up forms: only the form that was used says thanks ---------- */
  // Shopify may mark every sign-up form on the page as sent once one of them is. Each thanks names its form, and
  // after sending the address ends #<form id>, so any other form goes back to showing its email field.
  function initPosted() {
    var used = location.hash.slice(1);
    document.querySelectorAll('[data-hg-done]').forEach(function (done) {
      if (done.getAttribute('data-hg-done') === used) return;
      var form = done.closest('form'), fields = form && form.querySelector('[data-hg-fields]');
      done.parentNode.removeChild(done);
      if (fields) fields.hidden = false;
    });
    document.querySelectorAll('[data-hg-mine]').forEach(function (panel) {
      if (panel.getAttribute('data-hg-mine') !== used && !panel.querySelector('[data-hg-game-errors]')) panel.hidden = true;
    });
  }

  /* ---------- Footer: reopen Shopify's cookie banner ---------- */
  // The banner script arrives after the page, and only when the banner is switched on, so keep checking for a while.
  function initCookies() {
    var item = document.querySelector('[data-hg-cookies]'), tries = 0;
    if (!item) return;
    item.querySelector('button').addEventListener('click', function () {
      if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
    });
    (function look() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { item.hidden = false; return; }
      if (++tries < 20) setTimeout(look, 500);
    })();
  }

  /* ---------- What's on: events move to Past events the day after their date ---------- */
  // The page is written with the date the shop last rendered it; this re-checks against the visitor's own date,
  // so a cached page never shows yesterday's event as coming up.
  function initEvents() {
    var d = new Date(), pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var today = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    document.querySelectorAll('[data-hg-events]').forEach(function (root) {
      root.querySelectorAll('[data-hg-end]').forEach(function (el) { if (el.getAttribute('data-hg-end') < today) el.hidden = true; });
      root.querySelectorAll('[data-hg-from]').forEach(function (el) { if (el.getAttribute('data-hg-from') < today) el.hidden = false; });
      var none = root.querySelector('[data-hg-events-none]'), past = root.querySelector('[data-hg-past]');
      if (none) none.hidden = !!root.querySelector('.hg-event:not([hidden])');
      if (past) past.hidden = !past.querySelector('.hg-look:not([hidden]), .hg-past__item');
    });
  }

  function init() {
    initPosted();
    initEvents();
    initCookies();
    initMenu(document.querySelector('[data-hg-menu]'));
    initHeader(document.querySelector('[data-hg-head]'));
    initCartCount();
    initScenes();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
